<po-page-default class="sr-admin-shell" p-title="Administração Smart Review">
  <po-tabs>
    <po-tab
      *ngFor="let tab of tabs"
      [p-label]="tabLabel(tab)"
      [p-active]="isActive(tab)"
      (p-click)="navigate(tab)">
    </po-tab>
  </po-tabs>

  <div class="sr-admin-outlet">
    <router-outlet></router-outlet>
  </div>
</po-page-default>
